import http from "../http-common";

class CertService {
  getAll() {
    return http.get("/certificates");
  }

  getCustomerCerts(customerID) {
    return http.get(`/certificates/?customerid=${customerID}`);
  }

  getLocationCerts(locationID) {
    return http.get(`/certificates/?locationid=${locationID}`);
  }

  getSourceCerts(sourceID) {
    return http.get(`/certificates/?sourceid=${sourceID}`);
  }

  getLolCerts(lolID) {
    return http.get(`/certificates/?lolid=${lolID}`);
  }

  getLolCertsCreatedBetween(lolID, createdBetween1, createdBetween2) {
    return http.get(`/certificates/?lolid=${lolID}&createdBetween1=${createdBetween1}&createdBetween2=${createdBetween2}`);
  }

  getCustomerCertsCreatedAfter(customerID, createdAfter) {
    return http.get(`/certificates/?customerid=${customerID}&createdAfter=${createdAfter}`);
  }

  getCustomerCertsCreatedBetween(customerID, createdBetween1, createdBetween2) {
    return http.get(`/certificates/?customerid=${customerID}&createdBetween1=${createdBetween1}&createdBetween2=${createdBetween2}`);
  }

  get(certID) {
    return http.get(`/certificates/${certID}`);
  }

  create(data) {
    return http.post("/certificates", data);
  }

  update(certID, data) {
    return http.put(`/certificates/${certID}`, data);
  }

  delete(certID) {
    return http.delete(`/certificates/${certID}`);
  }

  deleteAll() {
    return http.delete(`/certificates`);
  }

  findByName(certNumber) {
    return http.get(`/customers?certnumber=${certNumber}`);
  }
}

export default new CertService();